<template>
  <b-row>
    <b-col cols="12" sm="12">
      <b-card class="mx-auto" tile>
        <InputBuscar :filter="filter" @input="filter = $event">
          <BotonAgregar @mostrarModalAgregar="mostrarModalAgregarGrupo" :textoBoton="$t('vGrupos.agregarGrupo')"
            :iconBoton="iconBoton" />
        </InputBuscar>
        <div class="row">
          <div class="col-md-12">
            <BaseTable tableClass="mb-3 tblgrupos tabla-grupos" :items="areas" :fields="translatedHeaders"
              :currentPage="currentPage" :perPage="perPage" :filter="filter" @filtered="onFiltered"
              :total-rows="totalRows">
              <template #cell(informacion)="data">
                <div>
                  <strong>{{ $t("vGrupos.usuariosAdmin") }}: </strong>
                  {{ data.item.administradores }} <br />
                  <strong>{{ $t("vGrupos.usuariosFinales") }}: </strong>
                  {{ data.item.finales }} <br />
                  <strong>{{ $t("vGrupos.numeroDispositivos") }}: </strong>
                  {{ data.item.dispositivos }}
                </div>
              </template>
              <template #cell(Acciones)="data">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="p-0 mr-2">
                    <b-form-checkbox switch size="sm" v-model="data.item.habilitado"
                      :set="(titulo = hoverHabilitado(data.item))" @click.native="mostrarDialog(data.item)"
                      v-b-tooltip.hover="hoverHabilitado(data.item.habilitado)">
                    </b-form-checkbox>
                  </div>
                  <b-button variant="link" class="p-0 border-0 shadow-none text-reset" @click="mostrarModalEditarGrupo(data.item)" v-b-tooltip.hover
                    :title="$t('Gral.editar')">
                    <feather type="edit" class="feather-sm mr-2"></feather>
                  </b-button>
                  <b-button variant="link" class="p-0 border-0 shadow-none text-reset" @click="mostrarModal(data.item)" v-b-tooltip.hover :title="$t('Gral.verUsuarios')"
                    style="margin-left: 0.313rem">
                    <feather type="users" class="feather-sm mr-2"></feather>
                  </b-button>
                </div>
              </template>
            </BaseTable>
          </div>
        </div>
        <template>
          <ModalAgregarGrupo ref="modalAgregarGrupo" @actualizarTabla="actualizarTabla" />
        </template>
        <template>
          <ModalEditarGrupo ref="modalEditarGrupo" :datosEditarGrupo="datosEditarGrupo"
            @actualizarTabla="actualizarTabla" />
        </template>
        <template>
          <InformacionGrupo ref="modalUsuarios" :datosGrupo="datosGrupo" :nombreGrupo="nombreGrupo" />
        </template>
        <template>
          <DialogConfirmar ref="dialogConfirmar" :mensaje="mensajeDialog" @confirmado="actualizarEstatus"
            @sinConfirmar="restablecerEstatus" />
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";

import AreaDataService from "../../../services/AreaDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from "../../../services/Crypto";

import InformacionGrupo from "./ModalInformacionGrupo.vue";
import ModalAgregarGrupo from "./ModalAgregarGrupo.vue";
import ModalEditarGrupo from "./ModalEditarGrupo.vue";
import BaseTable from "../../components/BaseTable.vue";
import BotonAgregar from "../../components/BotonAgregar.vue";
import InputBuscar from "../../components/InputBuscar.vue";
import DialogConfirmar from "../../components/DialogConfirmar.vue";

import { generalSweetAlert } from "../../../utils/Utils";

export default {
  name: "Areas",
  components: {
    InformacionGrupo,
    ModalAgregarGrupo,
    ModalEditarGrupo,
    BaseTable,
    BotonAgregar,
    InputBuscar,
    DialogConfirmar,
  },
  data() {
    return {
      areas: [],
      area: {
        id: 0,
        nombre: "",
        habilitado: false,
        adminIds: [],
      },
      datosEditarGrupo: {},
      mensajeDialog: "",
      grupoSeleccionado: null,
      datosGrupo: {},
      nombreGrupo: "",
      nameState: null,
      headers: [
        {
          key: "nombre",
          label: "nombre",
          sortable: true,
        },
        {
          key: "informacion",
          label: "informacion",
        },
        {
          class: "largo-columna-acciones",
          key: "Acciones",
          label: "acciones",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filter: null,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: "",
      existeNombre: false,
      campoValido: true,
      oldNombreArea: "",
      iconBoton: "plus-circle",
    };
  },

  mounted() {
    this.key = sessionStorage.getItem("key");
    this.$nextTick(() => {
      this.obtenerTodos();
    });
  },
  computed: {
    ...mapState(["locale"]),
    translatedHeaders() {
      // Mapea y traduce las etiquetas del arreglo headers.
      return this.headers.map((header) => {
        if (typeof header === "object" && header.label) {
          return {
            ...header,
            label: this.$t(`tableHeaders.${header.label}`),
          };
        } else {
          return header;
        }
      });
    },
  },
  methods: {
    /**
     * Asynchronously displays a modal with user information for a selected group.
     *
     * @param {Object} grupo - The group object for which the modal should be displayed.
     */
    async mostrarModal(grupo) {
      await this.informacionGrupo(grupo);
      if (this.datosGrupo) {
        this.nombreGrupo = grupo.nombre;
        this.$refs.modalUsuarios.showModal();
      }
    },

    /**
     * Fetches and sets the information of a specific group.
     *
     * @param {Object} grupo - The group object containing the group's details.
     * @param {number} grupo.id - The unique identifier of the group.
     * @param {string} grupo.nombre - The name of the group.
     *
     * @returns {Promise<void>} - A promise that resolves when the group information is successfully fetched and set.
     *
     * @throws Will log an error message to the console if the request fails.
     */
    async informacionGrupo(grupo) {
      try {
        const res = await AreaDataService.getInformacionGrupo(
          grupo.id,
          this.key
        );
        this.datosGrupo = res.data;
      } catch (error) {
        console.error("Error al obtener la informacion del grupo: ",error)
       }
    },

    mostrarModalAgregarGrupo() {
      this.$refs.modalAgregarGrupo.showModal();
    },

    mostrarModalEditarGrupo(grupo) {
      this.datosEditarGrupo = { ...grupo };

      this.$nextTick(() => {
        this.$refs.modalEditarGrupo.showModal();
      });
    },

    async actualizarTabla(responseStatus) {
      if (responseStatus === 201) {
        await this.obtenerTodos();
      }
    },

    mostrarDialog(datos) {
      this.grupoSeleccionado = datos;
      const habilitarTranslate = datos.habilitado
        ? this.$t("Gral.des")
        : this.$t("Gral.h");

      this.mensajeDialog = this.$t("vGrupos.msgHabilitar", {
        frase: habilitarTranslate,
      });

      this.$nextTick(() => {
        this.$refs.dialogConfirmar.openDialog();
      });
    },

    async actualizarEstatus() {
      try {
        if (!this.grupoSeleccionado) return;

        const habilitarTranslate = this.grupoSeleccionado.habilitado
          ? this.$t("Gral.h")
          : this.$t("Gral.des");
        const habilitarAccion = this.grupoSeleccionado.habilitado
          ? "h"
          : "desh";

        const response = await AreaDataService.create(
          this.grupoSeleccionado,
          this.key
        );

        if (response.status == 201) {
          this.accion =
            "Ha " +
            habilitarAccion +
            "abilitado la marca " +
            this.grupoSeleccionado.nombre;
          this.registrarAccion();
          await this.obtenerTodos();
          this.grupoSeleccionado = null;

          const mensaje = this.$t("vGrupos.msgHabilitarToast", {
            frase: habilitarTranslate,
          });
          generalSweetAlert(mensaje, "success");
        }
      } catch (error) {
        console.error("Error al actualizar el estatus del grupo: ",error)
        generalSweetAlert(this.$t("vGrupos.msgErrorHabilitar", "error"));
      }
    },

    restablecerEstatus() {
      this.grupoSeleccionado.habilitado = !this.grupoSeleccionado.habilitado;
      this.grupoSeleccionado = null;
    },

    async obtenerTodos() {
      try {
        const response = await AreaDataService.getAll();
        const decoded = await Crypto.desencriptar(response.data, this.key);

        const idRol = sessionStorage.getItem("idRol");
        const idUser = sessionStorage.getItem("id_user");

        // parseo de usuarioFiltro
        let usuarioFiltro = null;
        const usuarioFiltroRaw = sessionStorage.getItem("usuarioFiltro");
        if (usuarioFiltroRaw) {
          try {
            usuarioFiltro = JSON.parse(usuarioFiltroRaw);
          } catch (err) {
            console.error("Error al obtener los grupos: ",err)
            usuarioFiltro = null;
          }
        }

        // filtrar áreas por id, adminIds puede venir como array o null
        const areasQueIncluyen = (areas, idUser) => {
          if (!Array.isArray(areas)) return [];
          const id = String(idUser);
          return areas
            .filter(
              (area) =>
                Array.isArray(area.adminIds) &&
                area.adminIds.map(String).includes(id)
            )
            .map(this.getDisplayTutorial);
        };

        // si hay usuarioFiltro válido y el rol permite aplicarlo 
        if (
          usuarioFiltro &&
          usuarioFiltro.id &&
          (idRol === process.env.VUE_APP_ID_MASTER ||
            idRol === process.env.VUE_APP_ID_ADMINISTRADOR)
        ) {
          this.areas = areasQueIncluyen(decoded, usuarioFiltro.id);
        } else if (idRol === process.env.VUE_APP_ID_MASTER) {
          // master sin filtro: ve All
          this.areas = Array.isArray(decoded)
            ? decoded.map(this.getDisplayTutorial)
            : [];
        } else if (idRol === process.env.VUE_APP_ID_ADMINISTRADOR) {
          // administrador: ver sólo sus áreas
          this.areas = areasQueIncluyen(decoded, idUser);
        } else {
          // resto de roles: sin áreas (o puedes cambiar la política aquí)
          this.areas = [];
        }

        this.totalRows = Array.isArray(this.areas) ? this.areas.length : 0;
      } catch (e) {
        console.error(e);
        generalSweetAlert(this.$t("vGrupos.msgErrorBuscar"), "warning");
      }
    },

    getDisplayTutorial(area) {
      return {
        id: area.id,
        nombre: area.nombre,
        habilitado: area.habilitado,
        dispositivos: area.countDispositivos || "Sin dispositivos",
        administradores:
          area.administradores.join(", ") || "Sin usuarios administradores",
        finales: area.finales || "Sin usuarios finales",
        adminIds: area.adminIds,
      };
    },

    hoverHabilitado(hab) {
      if (hab) return this.$t("Gral.deshabilitar");
      else return this.$t("Gral.habilitar");
    },

    registrarAccion() {
      const data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
.card-body {
  margin: 0.7rem;
}

.largo-columna-acciones {
  width: 200px;
}

@media only screen and (max-width: 1600px) {
  .largo-columna-acciones {
    width: 200px;
  }
}

@media screen and (max-width: 991px) {
  .largo-columna-acciones {
    width: 200px;
  }
}

@media (max-width: 959px) {

  .boton-limpiar,
  .boton-agregar {
    margin-top: -16px;
  }

  .tabla-grupos {
    margin-top: -8px;
  }
}

@media (min-width: 960px) {

  .boton-limpiar,
  .boton-agregar {
    margin-top: 0px !important;
  }
}

@media screen and (max-width: 767px) {
  .largo-columna-acciones {
    width: 100px;
  }
}

@media screen and (max-height: 450px) {
  .largo-columna-acciones {
    width: 100px;
  }
}

@media screen and (max-width: 599px) {
  .margin-top-div-boton-guardar {
    margin-top: -12px;
  }
}

@media screen and (min-width: 600px) {
  .margin-top-div-boton-guardar {
    margin-top: 0px;
  }
}

@media (max-width: 991.98px) and (max-height: 950px) {

  /* Force table to not be like tables anymore */
  .tblgrupos table,
  .tblgrupos thead,
  .tblgrupos tbody,
  .tblgrupos th,
  .tblgrupos td,
  .tblgrupos tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .tblgrupos thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .tblgrupos tr {
    border: 1px solid #ccc;
  }

  .tblgrupos td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 5%;
    text-align: left;
  }

  .tblgrupos td:after {
    /* Now like a table header */
    position: relative;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 70%;
    padding-right: 10px;
    white-space: nowrap;
  }

  /*
	Label the data
	*/
  .tblgrupos td:nth-of-type(1):before {
    content: "Nombre: ";
  }

  .tblgrupos td:nth-of-type(2):before {
    content: "Información general: ";
  }

  .tblgrupos td:nth-of-type(3):before {
    content: "Acciones: ";
  }
}
</style>
